var Curriculog = Curriculog || {};

Curriculog.Hermes = (function ($, _, Backbone, Hermes, dom) {
	/**
	 * Get a unique array of all the values for a specific field.
	 * @param  {Number} mapID     The Hermes map ID
	 * @param  {String} fieldName The name of the field in the map
	 * @return {Array} a unique arraay of datastore_attribute values
	 */
	var fetchDatastoreAttributes = function (mapID, fieldName) {
		var params = $.param({map_id: mapID, field_name: fieldName});
		var url = '/rest/datastoreattributes.json?' + params;
		return $.ajax({
			type: 'GET',
			url: url
		});
	};

	/**
	 * MappedField
	 *   This model represents a field in a Hermes import map
	 *
	 *   The `fetchDatastoreAttributes` method will populate the `attributes`
	 *   attribute when it is called.
	 *
	 * 	 `attributes` is an array of distinct values for this field in the map,
	 * 	 which come from the DatastoreAttibutes collection.
	 */
	Hermes.MappedField = Backbone.Model.extend({
		parse: function (response) {
			return {
				mapID: response.map_id,
				fieldName: response.field_name,
				attributes: []
			};
		},
		/**
		 * Fetch the related attributes.
		 *
		 * @return {Array} This will return an array of all the distinct values
		 *	for the field.
		 */
		fetchDatastoreAttributes: function () {
			var fieldModel = this;
			return fetchDatastoreAttributes(this.get('mapID'), this.get('fieldName'))
			.then(function (response) {
				fieldModel.set('attributes', response);
				return response;
			});
		},
	});

	/**
	 * MappedFields is a collection of MappedField models
	 */
	Hermes.MappedFields = Backbone.Collection.extend({
		model: Hermes.MappedField,
		initialize: function (models, options) {
			this.mapID = options.mapID;
		},
		url: function () {
			return '/rest/mappedfields?map_id=' + this.mapID;
		}
	});

	return Hermes;
})($, _, Backbone, Curriculog.Hermes || {}, dom);
